import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import i18next from "i18next";
import memoizeOne from "memoize-one";

import { Quarter } from "api/generated/model";
import { GenericMultiCheckboxes } from "org/control/list/controls/common/genericMultiCheckboxes";

type OnChangeCallback = (key: Quarter, value: boolean) => void;

interface CommonProps {
    quarters: Record<Quarter, boolean[]>;
}
type EditProps = CommonProps & { onChange: OnChangeCallback };
type ReadOnlyProps = CommonProps;
type MultiQuarterlyCheckboxesProps =
    | ({ type: "EDIT" } & EditProps)
    | ({ type: "READ_ONLY" } & ReadOnlyProps);

function MultiQuarterlyCheckboxes(props: MultiQuarterlyCheckboxesProps) {
    const { labels, allLabel } = prepareLabels(i18next.language);

    switch (props.type) {
        case "EDIT": {
            const { quarters, onChange } = props;
            return (
                <GenericMultiCheckboxes
                    type="EDIT"
                    labels={labels}
                    allLabel={allLabel}
                    values={quarters}
                    onChange={onChange}
                />
            );
        }
        case "READ_ONLY": {
            const { quarters } = props;
            return (
                <GenericMultiCheckboxes
                    type="READ_ONLY"
                    labels={labels}
                    allLabel={allLabel}
                    values={quarters}
                />
            );
        }
        default: {
            return assertNever(props);
        }
    }
}

// Pass language (although it's not used explicitly) to ensure memoizeOne resets the cache
// if the language changes.
const prepareLabels = memoizeOne((_language: string) => {
    return {
        labels: {
            First: t("Quarter_1"),
            Second: t("Quarter_2"),
            Third: t("Quarter_3"),
            Fourth: t("Quarter_4"),
        },
        allLabel: t("CreateControl_Recurrence_ScheduleAllQuarters"),
    };
});

export { MultiQuarterlyCheckboxes, type MultiQuarterlyCheckboxesProps };
